<app-dialog class="municipality-onboarding-modal" *ngIf="!isCancelShown" [hideClose]="true">
  <ng-container>
    <div class="header-close-wrapper">
      <h4 class="header">
        {{ 'module.modals.onboarding.onboardingModalTitle' | translate }}
      </h4>
      <div class="close-button" (click)="closeModal()">x</div>
    </div>
  </ng-container>

  <div class="municipality-onboarding-modal-content-container">
    <ng-container>
      <form [formGroup]="municipalityOnboardingForm">
        <ng-container>
          <div class="modal-description">
            {{ 'module.modals.onboarding.onboardingModalDescription' | translate }}
          </div>

          <div class="form-header">
            {{ 'module.modals.onboarding.onboardingModalHeader' | translate }}
          </div>
          <div class="form-array-container" formArrayName="keyArray">
            <div class="key-field-container" *ngFor="let key of keyArray.controls; let i = index">
              <div class="input-icons-wrapper">
                <div class="input-field-wrapper">
                  <input
                    [ngClass]="{
                      'input-error': key.pending === true,
                      'input-validated': key.disabled === true
                    }"
                    class="input-field"
                    type="text"
                    [formControlName]="i"
                    required
                    minlength="8"
                    maxlength="8"
                    (blur)="getFormControlStatus(i)"
                    (keydown.enter)="getFormControlStatus(i)"
                  />
                  <div id="hideMe" *ngIf="key.disabled" class="check">
                    <app-svg-icon src="./assets/icons/icon_check.svg"></app-svg-icon>
                  </div>
                  <mat-spinner *ngIf="currIndex === i && isVerifying === true" [diameter]="20" class="field-spinner" mode="indeterminate"></mat-spinner>
                </div>
                <div class="action-icons-container">
                  <div *ngIf="key.disabled" class="edit-icon" aria-hidden="true" id="edit-icon" (click)="onEditClick(i)">
                    <app-svg-icon src="./assets/icons/icon_pencil.svg"></app-svg-icon>
                  </div>
                  <div *ngIf="keyArray.controls.length > 1" (click)="removeField(i)" class="remove-icon" aria-hidden="true" id="remove-icon">
                    <app-svg-icon src="./assets/icons/icon_remove.svg"></app-svg-icon>
                  </div>
                </div>
              </div>
              <div *ngIf="key.pending" class="error-message">
                {{ displayErrorMessage(i) }}
              </div>
            </div>
          </div>
        </ng-container>
      </form>

      <button class="add-field" *ngIf="keyArray.controls.length <= 4" (click)="onAddFieldClick()">
        <app-svg-icon class="icon-add" src="./assets/icons/icon_add_circle.svg"></app-svg-icon
        >{{ 'module.modals.onboarding.onboardingModalAddButtonLabel' | translate }}
      </button>
    </ng-container>

    <ng-container>
      <div class="onboarding-actions">
        <button class="btn btn-outline-primary" [disabled]="isDisabled" (click)="onSubmitClick()">
          <span class=""></span> {{ 'module.modals.onboarding.onboardingModalSubmitButtonLabel' | translate }}
        </button>

        <button class="btn btn-outline-secondary onboarding-btn-secondary" (click)="onCancelClick()">
          {{ 'module.modals.onboarding.onboardingModalCancelButtonLabel' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</app-dialog>
